import { create, StateCreator } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createSelectors } from './utils';

export type PreviewViewport = 'desktop' | 'mobile';

interface MembershipsConfigState {
  configPanelWidth: number | null;
  setConfigPanelWidth: (width?: number | null) => void;
  previewViewport: PreviewViewport;
  setPreviewViewport: (viewport: PreviewViewport) => void;
}

// Keys must be present here, not added lazily: `createSelectors` builds its hooks from
// `Object.keys` at module init. Older persisted sessions lack the key, hence the default.
const membershipsConfigInitializer: StateCreator<MembershipsConfigState> = (set) => ({
  configPanelWidth: null,
  setConfigPanelWidth: (width?: number | null) => set({ configPanelWidth: width ?? null }),
  previewViewport: 'desktop',
  setPreviewViewport: (viewport: PreviewViewport) => set({ previewViewport: viewport }),
});

const useMembershipsConfigStoreRaw = create<
  MembershipsConfigState,
  [['zustand/persist', unknown]]
>(
  persist(
    (...args) => ({
      ...membershipsConfigInitializer(...args),
    }),
    {
      name: 'pt-memberships-config',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export const useMembershipsConfigStore = createSelectors(useMembershipsConfigStoreRaw);
